import { MetricData } from '@src/data/body-measurement'

export class BodyMeasurementsService {

  static convertToChartDTO (array: MetricData[]) {
    return array
      .slice().sort((a, b) => a.effectiveAt > b.effectiveAt ? 1 : a.effectiveAt < b.effectiveAt ? -1 : 0)
      .map(element => {
        let date = new Date(element.effectiveAt)
        date.setHours(0, 0, 0, 0)
        return [date.getTime(), element.value]
      })
  }

  static convertToHistoryDTO (array: MetricData[], type: string) {
    return array.map(element => {
      return { ...element, type: type }
    })
  }
}
